import { Button } from "@progress/kendo-react-buttons";
import { ComboBox, MultiSelect } from "@progress/kendo-react-dropdowns";
import { GridToolbar } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import showConfirmationModal from "../../commons/helpers/ConfirmationModal";
import { approuveDefinitions } from "../../configs/ApprouveDefinition";
import { useGetAcheteursQuery, useGetTachesAutomatiseesQuery } from "../../redux/api/cache";
import { setButtonsState, setFormModified } from "../../redux/slices/appStateSlice";
import { useAppSelector } from "../../redux/store";
import "./toolbar.css";

interface ToolbarProps {
    onSearchChange: any;
    buttonsState: any;
    searchField: string;
    statuts: string;
    setStatuts: React.Dispatch<React.SetStateAction<string>>;
    acheteur: string;
    setAcheteur: React.Dispatch<React.SetStateAction<string>>;
    approuveFrancais: boolean | null;
    setApprouveFrancais: React.Dispatch<React.SetStateAction<boolean | null>>;
    approuveAnglais: boolean | null;
    setApprouveAnglais: React.Dispatch<React.SetStateAction<boolean | null>>;
    showFiltreTaches: boolean;
}

export default function Toolbar(props: ToolbarProps) {
    const dispatch = useDispatch();
    const formModified = useAppSelector(state => state.appState.formModified);
    const { data: acheteurs = [] } = useGetAcheteursQuery();
    const { data: tachesAutomatisees = [] } = useGetTachesAutomatiseesQuery();
    const [statutsValues, setStatutsValues] = useState(props.statuts ? props.statuts.split(",") : []);

    useEffect(() => {
        setStatutsValues(props.statuts ? props.statuts.split(",") : []);
    }, [props.statuts])

    const handleGridClick = (display: { gridView: boolean, listView: boolean }) => {
        if (formModified === 0 || showConfirmationModal()) {
            dispatch(setFormModified(0));
            dispatch(setButtonsState(display));
        }
    };

    const handleListViewClick = (display: { gridView: boolean, listView: boolean }) => {
        dispatch(setButtonsState(display));
    };

    const getApprouveValue = (approuve: any, nonApprouve: any) => {
        if (approuve && !nonApprouve)
            return true;
        else if (!approuve && nonApprouve)
            return false;
        return null;
    };

    return <GridToolbar className="k-flex-shrink-0">
        <div className="k-d-flex k-flex-row k-grid-rows-1 k-min-w-full k-max-w-0 k-gap-1">
            <div className="k-flex-grow k-w-full k-max-w-full k-d-flex k-flex-wrap k-gap-1">
                {props.showFiltreTaches && (<MultiSelect className="k-flex-shrink-0 k-max-w-full" data={tachesAutomatisees} placeholder='Tâches...' textField='descriptionCourte' dataItemKey='id' onChange={(e) => {
                    let statutsQuery = e.value.map((s: any) => s.code).join(',');
                    props.setStatuts(statutsQuery);
                }} value={tachesAutomatisees.filter(t => statutsValues.includes(t.code))} />)}
                <MultiSelect className="k-flex-shrink-0 k-max-w-full" data={approuveDefinitions} placeholder='Approuvé...' textField='descr' dataItemKey='idx' onChange={(e) => {
                    const approuveFrancais = e.value.find((e: any) => e.abreg === 'appr_web');
                    const nonApprouveFrancais = e.value.find((e: any) => e.abreg === 'non_appr_web');
                    props.setApprouveFrancais(getApprouveValue(approuveFrancais, nonApprouveFrancais));
                    const approuveAnglais = e.value.find((e: any) => e.abreg === 'appr_web_angl');
                    const nonApprouveAnglais = e.value.find((e: any) => e.abreg === 'non_appr_web_angl');
                    props.setApprouveAnglais(getApprouveValue(approuveAnglais, nonApprouveAnglais));
                }}
                    adaptive={true} />
                <ComboBox className="k-flex-shrink-0 k-max-w-full" data={acheteurs} placeholder='Acheteur...' textField='usr_nom' dataItemKey='usr_cd'
                    onChange={(e) => props.setAcheteur(e.value ? e.value.usr_cd : "")} adaptive={true} />
            </div>
            <div className="k-flex-grow-0 k-d-flex k-flex-row k-place-content-end k-align-items-end">
                <input
                    autoComplete="off"
                    placeholder="Rechercher"
                    title="Rechercher"
                    className="k-input"
                    onChange={props.onSearchChange}
                    value={props.searchField}
                    style={{ width: "200px" }}
                />
                <Button icon="grid" className="k-ml-md toolbar-grid-icon" selected={props.buttonsState.gridView} onClick={() => handleGridClick({ gridView: true, listView: false })} togglable={true} />
                <Button icon="grid-layout" className="toolbar-grid-layout-icon" selected={props.buttonsState.listView} onClick={() => handleListViewClick({ gridView: false, listView: true })} togglable={true} />
            </div>
        </div>
    </GridToolbar>;
}